var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUpArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 51,
  viewBox: "0 0 16 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 8L14.59 9.41L9 3.83V51H7V3.83L1.42 9.42L0 8L8 0L16 8Z",
  fill: "black"
})));
export default SvgIconUpArrow;